
import { AdminTitle } from "../../../store/reducers/site";
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'
import ShopPagination from "./shopPagination";
import { useDispatch, useSelector } from 'react-redux';
import { getPaginateShops } from "../../../store/actions/shopAction";


import {
    Modal,
    Button,
    ButtonToolbar,
    ButtonGroup,
    InputGroup,
    FormControl
} from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap'

const AdminShops = () => {

    const adminShops = useSelector(state=>state.shopReducer);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [removeAlert,setRemoveAlert] = useState(false);
    const [toRemove,setToRemove] = useState(null);


    const handleClose = () => setRemoveAlert(false);
    const handleShow = (id=null) => {
        setToRemove(id)
        setRemoveAlert(true)
    }


       //// START PAGINATION COMMANDS 
       const goToPrevPage = (page) => {
        dispatch(getPaginateShops({page}))
    }   

    const goToNextPage = (page) => {
        //console.log(page)
        dispatch(getPaginateShops({page}))
    }   
    const goToEdit = (id) => {
        navigate(`/dashboard/shopofc/edit/${id}`)
    }

    const goToImageupload = (id) => {
        navigate(`/dashboard/shop/imageupload/${id}`)

    }

    const goToNewsView=(id)=>{
       
        //component={RouterLink}
        //to={`/articles/article/${id}`}
       navigate(`/dashboard/shopofc/shop/${id}`)
       
    }

    const handleDelete = () => {
        // dispatch(removeArticle(toRemove))
        // .unwrap()
        // .finally(()=>{
        //     setRemoveAlert(false);
        //     setToRemove(null)
        // })
    }


   // http://localhost:3000/articles/article/20202260120282136

//// END PAGINATION COMMANDS 


    useEffect(()=>{
        dispatch(getPaginateShops({}))

        console.log("11111113333")
    console.log(adminShops.shops)
    console.log("22222223333332");

    },[])


    return(
        <>
        <AdminTitle title="Stores"/>
        <div className='articles_table'>
            <ButtonToolbar className='mb-3'>
                <ButtonGroup className='me-2'>
                    <LinkContainer to="/dashboard/shops/add">
                        <Button variant='secondary'>Add Shop or Event</Button>
                    </LinkContainer>
                </ButtonGroup>
                <form>
                    <InputGroup>
                        <InputGroup.Text id="btngrp1">@</InputGroup.Text>
                        <FormControl
                            type='text'
                            placeholder='Search'
                        />
                    </InputGroup>
                </form>
            </ButtonToolbar>

            <>
          
            { <ShopPagination
                    shops={adminShops.shops}
                    goToPrevPage={(page)=> goToPrevPage(page)}
                    goToNextPage={(page)=> goToNextPage(page)}
                    goToEdit={(id)=> goToEdit(id)}
                    goToImageupload={(id)=> goToImageupload(id)}
                    goToNewsView={(id)=> goToNewsView(id)}
                /> }


                       
            </>

            <Modal show={removeAlert} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title> Are you really sure ?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    There is no going back.
                </Modal.Body>
                <Modal.Footer>
                    <Button variant='secondary' onClick={handleClose}>
                        Oops, close this.
                    </Button>
                    <Button variant='danger' onClick={()=>handleDelete()}>
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal>


        </div>
        </>
    )

}

export default AdminShops;